/**
 * One URL search parameter as state, so a shared link opens the same view (starter-system-r1 section 8). The Drawer
 * keeps its id here (`?open=box:lowtide`), so a phone push links straight to it.
 */
import { useCallback } from 'react'
import { useNav } from '../nav'

export interface Param {
  value: string | null
  set: (value: string, opts?: { replace?: boolean }) => void
  clear: () => void
}

export function useParam(name: string): Param {
  const { where, navigate } = useNav()
  const value = new URLSearchParams(where.search).get(name)
  const write = useCallback(
    (v: string | null, replace = false) => {
      const p = new URLSearchParams(where.search)
      if (v === null || v === '') p.delete(name)
      else p.set(name, v)
      const qs = p.toString()
      navigate(`${where.pathname}${qs ? `?${qs}` : ''}`, { replace })
    },
    [where.pathname, where.search, name, navigate],
  )
  return {
    value,
    set: (v, opts) => write(v, opts?.replace),
    clear: () => write(null),
  }
}
